import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element }) => {
  const apiToken = localStorage.getItem('api_token');

  return apiToken ? element : <Navigate to="/" />;
};

export default PrivateRoute;